/* ════════════════════════════════════════════════════════════════════════
   Cart error handler — replaces Shopify.onError from global.js without
   editing that file. Loaded right after global.js (snippets/global-script).

   The original used eval() on the response (throws on an HTML 503 page)
   and alert(), and never stopped the add-to-cart spinner. Shopify.addItem
   calls Shopify.onError on every failed add, so this version:
     - parses the response with JSON.parse, falling back to a plain message
       when the body is HTML or empty;
     - finds the add-to-cart button that is still spinning and stops it;
     - shows Shopify's message: on the new mobile PDP as a bubble above the
       button (floated, so the layout doesn't move — see
       component-product-page-mobile-pdp.css); everywhere else in the
       theme's warning popup, so other templates' layout isn't pushed down.
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  if (!window.Shopify) return;

  var GENERIC_MESSAGE = "Something went wrong. Please try again.";
  var LOADING_BUTTON_SELECTOR =
    "[data-btn-addtocart].is-loading, [data-btn-addtocart] .is-loading, .show-warranty-popup-ab.is-loading";
  // Only here is the inline error styled to float without shifting layout.
  var INLINE_ERROR_CONTAINER = ".mpd-atc-wrap";

  function parseErrorResponse(responseText) {
    if (typeof responseText !== "string" || !responseText.trim()) return null;
    try {
      var data = JSON.parse(responseText);
      return data && typeof data === "object" ? data : null;
    } catch (_) {
      return null; // HTML error page (503 etc.)
    }
  }

  function messageFrom(data) {
    if (!data) return "";
    if (typeof data.description === "string" && data.description) return data.description;
    if (typeof data.message === "string" && data.message) return data.message;
    var parts = [];
    for (var key in data) {
      if (Array.isArray(data[key])) {
        for (var i = 0; i < data[key].length; i++) parts.push(key + " " + data[key][i]);
      }
    }
    return parts.join("; ");
  }

  function showInlineError(anchor, text) {
    var box = anchor.nextElementSibling;
    if (!box || !box.classList.contains("atc-inline-error")) {
      box = document.createElement("p");
      box.className = "atc-inline-error";
      box.setAttribute("role", "alert");
      anchor.insertAdjacentElement("afterend", box);
    }
    box.textContent = text;
  }

  function showWarningPopup(text) {
    var content = document.querySelector("[data-halo-warning-content]");
    if (!content) return console.error(text);
    content.textContent = text;
    document.body.classList.add("has-warning");
    clearTimeout(showWarningPopup.timer);
    showWarningPopup.timer = setTimeout(function () {
      document.body.classList.remove("has-warning");
    }, 3000);
  }

  // Clear a previous error as soon as the customer tries again.
  document.addEventListener(
    "click",
    function (e) {
      var btn = e.target.closest && e.target.closest("[data-btn-addtocart], .show-warranty-popup-ab");
      var box = btn && btn.nextElementSibling;
      if (box && box.classList.contains("atc-inline-error")) box.remove();
    },
    true
  );

  // Same signature as global.js; `target` (element or jQuery) is optional.
  Shopify.onError = function (XMLHttpRequest, textStatus, message, target) {
    var text =
      messageFrom(parseErrorResponse(XMLHttpRequest && XMLHttpRequest.responseText)) ||
      message ||
      GENERIC_MESSAGE;

    var anchor = target && target.jquery ? target[0] : target;
    var spinning = document.querySelector(LOADING_BUTTON_SELECTOR);
    if (spinning) {
      spinning.classList.remove("is-loading");
      if (!anchor || anchor.nodeType !== 1) {
        anchor = spinning.closest("[data-btn-addtocart], .show-warranty-popup-ab") || spinning;
      }
    }

    if (anchor && anchor.nodeType === 1 && anchor.closest(INLINE_ERROR_CONTAINER)) {
      showInlineError(anchor, text);
    } else {
      showWarningPopup(text);
    }
  };
})();
